import * as React from "react";
import useSWR from "swr";
import fetcher from "./fetcher";

const baseEndpoint = "/api/influencer";

export default function useInfluencerCharacters(influencerId) {
  const url = influencerId
    ? `${baseEndpoint}/${influencerId}/characters`
    : null;

  const { data, error, mutate } = useSWR(url, fetcher);

  const characters = React.useMemo(() => {
    if (!Array.isArray(data?.characters)) {
      return [];
    }
    return data.characters;
  }, [data]);

  return {
    characters,
    isLoading: !data && !error && Boolean(influencerId),
    isError: Boolean(error),
    error,
    refresh: mutate,
  };
}
